import { GetMeDocument, type GetMeQuery, setUserStore } from '@/entities/user';
import { getApolloClient } from '@/shared/api/apollo-client';

const client = getApolloClient();

export async function initUserDataStore() {
  try {
    const { data } = await client.query<GetMeQuery>({
      query: GetMeDocument,
    });

    if (data.getMe) {
      setUserStore(data.getMe);
    }
  } catch (e) {
    console.error(`Error while init user store: ${e}`);
    setUserStore(null);
  }
}
